var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressDetailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#FFF7C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 22.3333H22.3333M25.6667 13.9999V23.9999C25.6667 24.4419 25.4911 24.8659 25.1785 25.1784C24.866 25.491 24.442 25.6666 24 25.6666H15.6667C15.2246 25.6666 14.8007 25.491 14.4882 25.1784C14.1756 24.8659 14 24.4419 14 23.9999V13.9999C14 13.5579 14.1756 13.134 14.4882 12.8214C14.8007 12.5088 15.2246 12.3333 15.6667 12.3333H24C24.442 12.3333 24.866 12.5088 25.1785 12.8214C25.4911 13.134 25.6667 13.5579 25.6667 13.9999Z",
    stroke: "#E07000",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.333 15.6665H14.833M12.333 18.9998H14.833M12.333 22.3332H14.833M18.1663 18.1665C18.1663 18.6085 18.3419 19.0325 18.6545 19.345C18.9671 19.6576 19.391 19.8332 19.833 19.8332C20.275 19.8332 20.699 19.6576 21.0115 19.345C21.3241 19.0325 21.4997 18.6085 21.4997 18.1665C21.4997 17.7245 21.3241 17.3006 21.0115 16.988C20.699 16.6754 20.275 16.4998 19.833 16.4998C19.391 16.4998 18.9671 16.6754 18.6545 16.988C18.3419 17.3006 18.1663 17.7245 18.1663 18.1665Z",
    stroke: "#E07000",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressDetailLogo);
export default __webpack_public_path__ + "static/media/AddressDetailLogo.abb36f9ef4873530da270cf081b7e14d.svg";
export { ForwardRef as ReactComponent };